var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"funnel-container pl-0 pr-0"},[_c('GChart',{attrs:{"type":"AreaChart","data":_vm.chartData,"options":_vm.chartOptions}}),_c('div',{staticClass:"chart-label"},[_vm._v(" "+_vm._s(_vm.invites[_vm.propertyBegin] || '\u00A0')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }